import React, { useState } from 'react';
import '../CSS/Global.css';
import cif from '../img/CIF VERTICAL.jpg';
import crimeAlert from '../img/CRIME ALERT VERTICAL.jpg';
import chandrakanta from '../img/CHANDRAKANTA VERTICAL.jpg';
import ekghar from '../img/EK GHAR BANAUNGA VERTICAL.jpg';
import gusthak from '../img/GUSTHAK DIL VERTICAL.jpg';
import rajumar from '../img/RAJKUMAR AARYAN VERTICAL.jpg';
import balika from '../img/BALIKA VADHU VERTICAL.jpg';
import shaurya from '../img/SHAURYA SUHANI VERTICAL.jpg';
import jyoti from '../img/JYOTI VERTICAL.jpg';
import naam from '../img/NAAMKARAN VERTICAL.jpg';
import romeo from '../img/ROMEO AND RADHIKA VERTICAL.avif';
import ratanpur from '../img/RATANPUR VERTICAL.avif';
import kaashi from '../img/KASHI VERTICAL.jpg';
import singham from '../img/SINGHAM VERTICAL.jpg';
import nawab from '../img/NAWABZAADE VERTICAL.jpg';
import gulmakai from '../img/GUL MAKAI VERTICAL.jpg';
import posterNotFound from '../img/posternotfound.webp';
import savdhan from '../img/SAVDHAN INDIA VERTICAL.jpg';
import ahilya from '../img/AHILYA VERTICAL.jpg';
import saavi from '../img/SAAVI KI SAVAARI VERTICAL.jpg';
import campus from '../img/CAMPUS BEATS VERTICAL.jpg';
import sai from '../img/MERE SAI vertical.jpg';
import cinema from '../img/CINEMA ZINDABAD vertical.jpg'


const MyProjects = () => {
    // State to manage active tab
    const [activeTab, setActiveTab] = useState('tvshowsAlbums');

    return (
        <>
            <div className="my-project">
                <h1>My Projects</h1>
                <p>Mazhar Khan has an impressive portfolio spanning over 30 projects in television, films, and advertisements.</p>
            </div>

            <div className="project-tab">
                <h2>Project name & production name</h2>
                <div className="tab-menu">
                    <button 
                        className={activeTab === 'tvshowsAlbums' ? 'active' : ''} 
                        onClick={() => setActiveTab('tvshowsAlbums')}
                    >
                        TV Shows & Promo
                    </button>
                    <button 
                        className={activeTab === 'filmsAdFilms' ? 'active' : ''} 
                        onClick={() => setActiveTab('filmsAdFilms')}
                    >
                        Films & Ad Films
                    </button>
                </div>

                <div className="tab-content">
                    {activeTab === 'tvshowsAlbums' && (
                        <>
                            <div className="project-card">
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={cif} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>White Sand Production-<br/>CIF TV Show </h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={chandrakanta} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Balaji Telefilm Ltd- <br/>Chandrakanta TV Show </h2>
                                        <p>Assistant Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={ekghar} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Village Boy Production- <br/>Ek Ghar Banaunga TV Show </h2>
                                        <p>Assistant Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={gusthak} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Ravi Ojha Production- <br/>Gustakh Dil TV Show </h2>
                                        <p>Assistant Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={posterNotFound} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Ding Entertainment- <br/>Web Series Assistant</h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={rajumar} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Spare Origin Production- <br/>Rajkumar Aaryan TV Show </h2>
                                        <p>Assistant Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={crimeAlert} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Jafra Productions-<br/>Crime Alert TV Show</h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={balika} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Spare Origin Production- <br/>Balika Vadhu Assistant </h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={shaurya} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Spare Origin Production- <br/>Shaurya Suhani TV Show Assistant </h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={jyoti} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Spare Origin Production- <br/>Jyoti TV Show </h2>
                                        <p>Assistant Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={naam} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Dhaval Gada Production- <br/>Naam Karan Serial </h2>
                                        <p>Assistant Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={savdhan} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Contiloe Production -<br/>Savdhan India </h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={sai} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Dashmi Creation -<br/>Mere Sai</h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={ahilya} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Dashmi Creation -<br/>Ahilyabai Holkar</h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={saavi} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Dashmi Creation -<br/>Saavi ki Savaari</h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={campus} alt="TV Show/Album" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Banijay Entertainment<br/>Campus Beats</h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                            </div>
                        </>
                    )}
                    {activeTab === 'filmsAdFilms' && (
                        <>
                            <div className="project-card">
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={cinema} alt="Film/Ad Film" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Udan Movie Production- <br/>Cinema Zindabad</h2>
                                        <p>Film Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={romeo} alt="Film/Ad Film" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Nakoda Production- <br/>Romeo and Radhika Gujarati Movie </h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={ratanpur} alt="Film/Ad Film" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Ratanpur Film- <br/>Gujarati Movie </h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={kaashi} alt="Film/Ad Film" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Insite India- <br/>Kaashi in Search of Ganga trailer movie Associate </h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={singham} alt="Film/Ad Film" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Panorama Production & Kumar Mangat Production- <br/>Singham 4 Punjabi Movie </h2>
                                        <p>Assistant Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                {/* <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={posterNotFound} alt="Film/Ad Film" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Ajay Devgan Presents</h2>
                                        <p>Assistant Art Director</p>
                                    </div>
                                    <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div>
                                </div> */}
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={nawab} alt="Film/Ad Film" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Remo D'souza-<br/>Nawabzaade Film </h2>
                                        <p>Assistant Art Director</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={gulmakai} alt="Film/Ad Film" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Amjad Khan Production- <br/>Gul Makai Movie </h2>
                                        <p>Art Director</p>
                                    </div>
                                    {/* <div className=hi"project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                                </div>
                                <h3> Ad Films</h3>
                                <div className="project-card">
                                    <div className="project-card-list">
                                    <div className="project-card-img">
                                        <img src={posterNotFound} alt="Ad Film" />
                                    </div>
                                    <div className="project-card-info">
                                        <h2>Bangur Cement</h2>
                                        <p>Art Directors</p>
                                    </div>
                                    {/* <div className="project-card-icons">
                                        <i className="fa-brands fa-instagram"></i>
                                        <i className="fa-brands fa-facebook"></i>
                                        <i className="fa-brands fa-youtube"></i>
                                    </div> */}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default MyProjects;
